<app-formulario #ctrl URL="alumno" titulo="Alumno / Control Escolar" [dato]="dato"></app-formulario>
<app-sistema-menu></app-sistema-menu>
<div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando">
    <div class="bloquear-azul">

    </div>
    <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
      <span class="icon">
        <i class="icon-worldwide fa-spin"></i>
      </span> &nbsp;
    <span>Cargando...</span>
    </span>
</div>
<div class="contenedor columns " style="height:100%; ">
    <div class="column is-hidden-mobile menu-izquierda is-2">
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">
            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato">
                <section class="hero is-primary">
                    <div class="hero-body">
                        <nav class="level">
                            <!-- Left side -->
                            <div class="level-left">
                                <div class="level-item">
                                    <p class="title">
                                        <span *ngIf="!ctrl.cargando" class="icon is-medium">
                                            <i class="icon-election"></i>
                                        </span>
                                        <span *ngIf="ctrl.cargando" class="icon is-medium">
                                            <i class="icon-worldwide fa-spin"></i>
                                        </span>
                                        <span class="icon is-medium">
                                            <i class="fa" [ngClass]="icon-id-card"></i>
                                        </span> Alumnos
                                    </p>
                                </div>

                            </div>

                            <!-- Right side -->
                            <div class="level-right">
                                <a class="navbar-item tooltip" (click)="ctrl.regresar()">
                                    <span class="icon fa-2x">
                                        <i class="icon-back"> </i>
                                    </span>
                                    <span class="tooltiptext">Regresar</span>
                                </a>

                                <a class="navbar-item tooltip" [ngClass]="{'is-loading': ctrl.cargando}" (click)="!ctrl.cargando ? ctrl.cargarDatos() : ''" id='cargar_datos_actualizar' *ngIf="ctrl.id">
                                    <span class="icon fa-2x">
                                        <i class="icon-worldwide"></i>
                                    </span>
                                    <span class="tooltiptext">Actualizar</span>
                                </a>
                            </div>
                        </nav>


                        <div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo">
                            <div class="bloquear-azul">

                            </div>
                            <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
                                <span class="icon">
                                    <i class="icon-worldwide fa-spin"></i>
                                </span> &nbsp;
                            <span>Cargando...</span>
                            </span>
                        </div>

                    </div>
                </section>

                <section class="section" style="padding: 2rem 2rem !important; overflow:auto; height: 86vh;">
                    <!-- <div class="is-fullwidth has-text-centered" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando">
                        <br>
                        <span class="tag is-primary is-large ">
                          <span class="icon">
                            <i class="icon-worldwide fa-spin"></i>
                          </span> &nbsp;
                        <span>Cargando...</span>
                        </span>
                    </div> -->

                    <!-- Generales -->
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                <i class="fa fa-vcard is-size-4 has-text-grey-light"> </i> &nbsp; Información General
                            </p>
                            <a href="javascript:void()" class="card-header-icon" aria-label="more options" (click)="acordeon[13] = !acordeon[13]">
                                <span class="icon">
                                    <i class="fa " [ngClass]="acordeon[13] ? 'fa-angle-down' : 'fa-angle-up'"
                                        aria-hidden="true"></i>
                                </span>
                            </a>
                        </header>
                        <div class="card-content" [ngClass]="acordeon[13] ? 'is-hidden' : ''">
                            <div class="content">
                                <div class="columns">
                                    <div class="column is-4">
                                        <div class="field" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') && ctrl.dato.get('nombre').hasError('required')}">
                                            <label class="label">Nombre:</label>
                                            <p class="control has-icons-left has-icons-right">
                                                <input class="input" type="text" placeholder="Nombre" formControlName="nombre">
                                                <span class="help is-danger" *ngIf="!ctrl.dato.get('nombre').hasError('required')">Este campo es requerido.</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="column is-4">
                                        <div class="field" [ngClass]="{'is-danger': ctrl.dato.get('apellido_paterno').hasError('required') && ctrl.dato.get('apellido_paterno').hasError('required')}">
                                            <label class="label">Apellido Paterno:</label>
                                            <p class="control has-icons-left has-icons-right">
                                                <input class="input" type="text" placeholder="Apellido Paterno" formControlName="apellido_paterno">
                                                <span class="help is-danger" *ngIf="!ctrl.dato.get('apellido_paterno').hasError('required')">Este campo es requerido.</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="column is-4">
                                        <div class="field" [ngClass]="{'is-danger': ctrl.dato.get('apellido_materno').hasError('required') && ctrl.dato.get('apellido_materno').hasError('required')}">
                                            <label class="label">Apellido Materno:</label>
                                            <p class="control has-icons-left has-icons-right">
                                                <input class="input" type="text" placeholder="Apellido Materno" formControlName="apellido_materno">
                                                <span class="help is-danger" *ngIf="!ctrl.dato.get('apellido_materno').hasError('required')">Este campo es requerido.</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div formGroupName="personas_metadatos">
                        <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                        <a id="catalogos" (click)="ctrl.tipos_regimenes_fiscales = [];  ctrl.cargarCatalogo('plan_pago', 'plan-pago-activo'); ctrl.cargarCatalogo('becas', 'beca', 'cargar_grupo'); ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar');  ctrl.cargarCatalogo('carreras_planes', 'carrera-plan', 'cargar_grupo'); ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>

                        <a id="cargar_grupo" (click)="carrera_plan($event, ctrl.dato.controls.personas_metadatos.controls.carreras_planes_id, 'grupo-periodo-carrera', 'grupos'); beca($event, ctrl.dato.becas_id, ctrl.carreras_planes, ctrl.becas); plan($event, ctrl.dato.controls.personas_metadatos.get('carreras_planes_id').value, ctrl.carreras_planes, ctrl.plan_pago);"></a>
                        <a id="imprimir_local" (click)="imprimir_ficha()"></a>
                        <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>

                        <!-- formulario dinamico -->
                        <a id="cargar_datos_dinamicos" (click)="tieneid ? ctrl.cargarDatos() : ''"></a>
                        <div *ngIf="formularioConstruido">
                            <div class="card" *ngFor="let form of formulario['alumno'].formularios_secciones; let i=index">
                                <header class="card-header">
                                    <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                        <i class="is-size-4 has-text-grey-light" [ngClass]="form.icono"> </i> &nbsp; {{ form.nombre }}
                                    </p>
                                    <a href="javascript:void()" class="card-header-icon" aria-label="more options" (click)="acordeon[i] = !acordeon[i]">
                                        <span class="icon">
                                            <i class="fa " [ngClass]="acordeon[i] ? 'fa-angle-down' : 'fa-angle-up'"
                                                aria-hidden="true"></i>
                                        </span>
                                    </a>
                                </header>
                                <div class="card-content" [ngClass]="acordeon[i] ? 'is-hidden' : ''">
                                    <div class="content">
                                        <div class="columns" *ngFor="let column of form.formularios_secciones_campos; ">
                                            <div class="column" [ngClass]="campo.clase" *ngFor="let campo of column; let c=index">
                                                <div class="field">
                                                    <label class="label" *ngIf="campo.tipo_dato != 'checkbox'">{{campo.descripcion}}:</label>
                                                    <div class="control has-icons-left has-icons-right">
                                                        <!-- inputs -->
                                                        <!-- <input class="input" *ngIf="campo.tipo_dato == 'text' || campo.tipo_dato == 'number' || campo.tipo_dato == 'email' || campo.tipo_dato == 'url' || campo.tipo_dato == 'phone' || campo.tipo_dato == 'date' || campo.tipo_dato == 'time'" [ngClass]="{'is-danger': ctrl.dato.controls.personas_metadatos.get(campo.campo).hasError('required') }"
                                                            [maxLength]="campo.longitud > 0 ? campo.longitud : 255" type="{{campo.tipo_dato}}" placeholder="{{campo.descripcion}}" formControlName="{{campo.campo}}">

                                                        <textarea class="textarea" rows="5" placeholder="{{campo.descripcion}}" formControlName="{{campo.campo}}" *ngIf="campo.tipo_dato == 'textarea'"></textarea> -->

                                                        <span *ngIf="campo.tipo_dato == 'text' || campo.tipo_dato == 'number' || campo.tipo_dato == 'email' || campo.tipo_dato == 'url' || campo.tipo_dato == 'phone' || campo.tipo_dato == 'date' || campo.tipo_dato == 'time'">{{ctrl.dato.controls.personas_metadatos.get(campo.campo).value}}</span>
                                                        <!-- select -->
                                                        <div class="" *ngIf="campo.tipo_dato == 'select'">

                                                            <ng-select2 *ngIf="!campo.es_dependiente" [disabled]="catalogosDinamicos[campo.campo] ? catalogosDinamicos[campo.campo].length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.personas_metadatos.get(campo.campo).value"
                                                                [data]="catalogosDinamicos[campo.campo]" (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.personas_metadatos.controls[campo.campo]);" [ngClass]="{'is-danger': ctrl.dato.controls.personas_metadatos.get(campo.campo).hasError('required') }">
                                                            </ng-select2>


                                                            <a id="id_{{campo.campo}}" (click)="obtenerCatalogosDependientesDinamicos(campo.campo_dependiente, ctrl.dato.controls.personas_metadatos.get(campo.campo).value)"></a>

                                                            <ng-select2 *ngIf="campo.es_dependiente" [disabled]="catalogosDinamicos[campo.campo] ? catalogosDinamicos[campo.campo].length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.personas_metadatos.get(campo.campo).value"
                                                                [data]="catalogosDinamicos[campo.campo]" (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.personas_metadatos.controls[campo.campo], '', '', 'id_'+campo.campo);" [ngClass]="{'is-danger': ctrl.dato.controls.personas_metadatos.get(campo.campo).hasError('required') }">
                                                            </ng-select2>
                                                        </div>

                                                        <!-- radio -->
                                                        <div *ngIf="campo.tipo_dato == 'radio' && campo.es_catalogo">
                                                            <div class="b-checkbox is-info is-circular" *ngFor="let item of catalogosDinamicos[campo.campo]; let x = index;" style="float: left;">
                                                                <input id="{{campo.campo}}{{x}}" name="{{campo.campo}}" value="{{item.id}}" class="styled" type="radio" formControlName="{{campo.campo}}">
                                                                <label for="{{campo.campo}}{{x}}">
                                                                    {{item.text ? item.text : item.nombre}}
                                                                </label>
                                                            </div>
                                                        </div>

                                                        <!-- checkbox -->
                                                        <div class="b-checkbox is-info" *ngIf="campo.tipo_dato == 'checkbox' && !campo.es_catalogo">
                                                            <input id="{{campo.campo}}" class="styled" [checked]="ctrl.dato.controls.personas_metadatos.get(campo.campo).value == 1 ? true : false" (change)="ctrl.dato.controls.personas_metadatos.get(campo.campo).patchValue(ctrl.dato.controls.personas_metadatos.get(campo.campo).value == 1 ? 0 : 1)"
                                                                type="checkbox">
                                                            <label for="{{campo.campo}}">
                                                                {{campo.descripcion}}
                                                            </label>
                                                        </div>

                                                        <!-- File -->
                                                        <div class="box" *ngIf="campo.tipo_dato == 'file'">
                                                            <article class="media">
                                                                <div class="media-left">
                                                                    <figure class="image is-64x64">
                                                                        <img [src]="'data:image/jpeg;base64,'+ctrl.dato.controls.personas_metadatos.get(campo.campo).value">
                                                                    </figure>
                                                                </div>
                                                                <div class="media-content">
                                                                    <div class="field">
                                                                        <label class="label">{{campo.descripcion}}:</label>
                                                                        <div class="control has-icons-left has-icons-right" *ngIf="ctrl.dato.controls.personas_metadatos.get(campo.campo).value == ''">

                                                                            <div class="file has-name">
                                                                                <label class="file-label">
                                                                                    <input type="file"
                                                                                        class="file-input"
                                                                                        (change)="ctrl.seleccionarImagenBase64($event, ctrl.dato.controls.personas_metadatos.controls[campo.campo], false, campo.campo)"
                                                                                        accept="image/x-png,image/gif,image/jpeg,image/jpg">
                                                                                    <span class="file-cta">
                                                                                        <span class="file-icon">
                                                                                            <i class="fa fa-upload"></i>
                                                                                        </span>
                                                                                        <span class="file-label">
                                                                                            Seleccionar archivo
                                                                                        </span>
                                                                                    </span>

                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                        <button type="button" class="button is-danger" (click)="ctrl.borrarImagen($event, ctrl.dato.controls.personas_metadatos.controls[campo.campo], 'configuracion')" *ngIf="ctrl.dato.controls.personas_metadatos.get(campo.campo).value != ''">
                                                                            <span class="icon">
                                                                                <i class="fa fa-trash"></i>
                                                                            </span>
                                                                            &nbsp; Eliminar.
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </article>
                                                        </div>

                                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get(campo.campo).hasError('required') ">
                                                            <i class="fa fa-warning"></i>
                                                        </span>
                                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get(campo.campo).hasError('required') ">Este
                                                            campo es requerido.</span>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Información escolar -->
                        <div class="card">
                            <header class="card-header">
                                <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                    <i class="fa fa-vcard is-size-4 has-text-grey-light"> </i> &nbsp; Información escolar
                                </p>
                                <a href="javascript:void()" class="card-header-icon" aria-label="more options" (click)="acordeon[6] = !acordeon[6]">
                                    <span class="icon">
                                        <i class="fa " [ngClass]="acordeon[6] ? 'fa-angle-down' : 'fa-angle-up'"
                                            aria-hidden="true"></i>
                                    </span>
                                </a>
                            </header>
                            <div class="card-content" [ngClass]="acordeon[6] ? 'is-hidden' : ''">
                                <div class="content">
                                    <div class="columns">

                                        <div class="column is-12">
                                            <label class="label">Período escolar:</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <ng-select2 name="periodos_escolares_id" [disabled]="ctrl.periodos_escolares ? ctrl.periodos_escolares.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.personas_metadatos.controls.periodos_escolares_id.value"
                                                    [data]="ctrl.periodos_escolares" (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.personas_metadatos.controls.periodos_escolares_id, '', '', 'periodo_escolar');">
                                                </ng-select2>

                                                <a id="periodo_escolar" (click)="carrera_plan($event, ctrl.dato.controls.personas_metadatos.controls.periodos_escolares_id, 'grupo-periodo-carrera', 'grupos');"></a>

                                                <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('periodos_escolares_id').hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                          </span>
                                                <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('periodos_escolares_id').hasError('required') ">Este campo es
                                            requerido.</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="columns">

                                        <div class="column is-6">
                                            <label class="label">Carrera/Plan:</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <ng-select2 name="carreras_planes_id" [disabled]="ctrl.carreras_planes ? ctrl.carreras_planes.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.personas_metadatos.controls.carreras_planes_id.value" [data]="ctrl.carreras_planes"
                                                    (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.personas_metadatos.controls.carreras_planes_id, '', '', 'carrera_plan');">
                                                </ng-select2>

                                                <a id="carrera_plan" (click)="carrera_plan($event, ctrl.dato.controls.personas_metadatos.controls.carreras_planes_id, 'grupo-periodo-carrera', 'grupos');  plan($event, ctrl.dato.controls.personas_metadatos.get('carreras_planes_id').value, ctrl.carreras_planes, ctrl.plan_pago); beca($event, ctrl.dato.becas_id, ctrl.carreras_planes, ctrl.becas);"></a>

                                                <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('carreras_planes_id').hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                          </span>
                                                <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('carreras_planes_id').hasError('required') ">Este campo es
                                            requerido.</span>
                                            </div>
                                        </div>

                                        <div class="column is-6">
                                            <label class="label">Grupo:</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <ng-select2 name="grupos_id" [disabled]="grupos ? grupos.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.personas_metadatos.controls.grupos_id.value" [data]="grupos" (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.personas_metadatos.controls.grupos_id, '', '', 'grupo');">
                                                </ng-select2>

                                                <a id="grupo" (click)="grupo($event, ctrl.dato.controls.personas_metadatos.get('grupos_id').value, ctrl.plan_pago);"></a>

                                                <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('grupos_id').hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                          </span>
                                                <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('grupos_id').hasError('required') ">Este campo es
                                            requerido.</span>
                                            </div>
                                        </div>

                                        <div class="column is-6">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--  Plan de pago y Beca -->
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                <i class="fa fa-dollar is-size-4 has-text-grey-light"> </i> &nbsp; Plan de pago y Beca
                            </p>
                            <a href="javascript:void()" class="card-header-icon" aria-label="more options" (click)="acordeon[7] = !acordeon[7]">
                                <span class="icon">
                                    <i class="fa " [ngClass]="acordeon[7] ? 'fa-angle-down' : 'fa-angle-up'"
                                        aria-hidden="true"></i>
                                </span>
                            </a>
                        </header>
                        <div class="card-content" [ngClass]="acordeon[7] ? 'is-hidden' : ''">
                            <div class="content">
                                <div class="columns">
                                    <div class="column is-6">
                                        <p>Los montos de Inscripción, reinscripción y colegiaturas se extraen del plan de pagos vigente. Si el alumno es acreedor a una beca o convenio de pago debe elegir la opción que convenga.</p>
                                    </div>

                                    <div class="column is-6">
                                        <label class="label">Becas/Convenios:</label>
                                        <div class="control has-icons-left has-icons-right">
                                            <ng-select2 name="becas_id" [disabled]="ctrl.becas ? ctrl.becas.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.becas_id.value" [data]="ctrl.becas" (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.becas_id, '', '', 'beca');">
                                            </ng-select2>

                                            <a id="beca" (click)="plan($event, ctrl.dato.controls.personas_metadatos.get('carreras_planes_id').value, ctrl.carreras_planes, ctrl.plan_pago); beca($event, ctrl.dato.controls.becas_id, ctrl.carreras_planes, ctrl.becas);"></a>

                                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('becas_id').hasError('required') ">
                                          <i class="fa fa-warning"></i>
                                        </span>
                                            <span class="help is-danger" *ngIf="ctrl.dato.get('becas_id').hasError('required') ">Este campo es
                                          requerido.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="columns">
                                    <table class="table" style="width:100%;" id="beca">
                                        <thead>
                                            <tr>
                                                <th> </th>
                                                <th> Inscripción </th>
                                                <th> Reinscripción </th>
                                                <th> Colegiatura </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style="width:40%; font-size:small;">Plan de pago actual</td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">
                                                    {{inscripcion | currency}}</td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">
                                                    {{reinscripcion | currency}}</td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">
                                                    {{colegiatura | currency}}</td>
                                            </tr>
                                            <tr *ngIf="ctrl.dato.controls.becas_id.value!='' && ctrl.dato.controls.becas_id.value!=null">
                                                <td style="font-size:small;">{{descripcion_beca}}</td>
                                                <td style="font-weight:bold; font-size:large;">{{texto_inscripcion}} {{beca_inscripcion | currency}}
                                                </td>
                                                <td style="font-weight:bold; font-size:large;">{{texto_reinscripcion}} {{beca_reinscripcion | currency}}
                                                </td>
                                                <td style="font-weight:bold; font-size:large;">{{texto_colegiatura}} {{beca_colegiatura | currency}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="font-size:small;">Total</td>
                                                <td style="font-weight:bold; font-size:large;">
                                                    {{inscripcion-beca_inscripcion | currency}}</td>
                                                <td style="font-weight:bold; font-size:large;">
                                                    {{reinscripcion-beca_reinscripcion | currency}}</td>
                                                <td style="font-weight:bold; font-size:large;">
                                                    {{colegiatura-beca_colegiatura | currency}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--  Situacion de pago -->
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                <i class="fa fa-vcard is-size-4 has-text-grey-light"> </i> &nbsp; Situación de pagos
                            </p>
                            <a href="javascript:void()" class="card-header-icon" aria-label="more options" (click)="acordeon[8] = !acordeon[8]">
                                <span class="icon">
                                    <i class="fa " [ngClass]="acordeon[8] ? 'fa-angle-down' : 'fa-angle-up'"
                                        aria-hidden="true"></i>
                                </span>
                            </a>
                        </header>
                        <div class="card-content" [ngClass]="acordeon[8] ? 'is-hidden' : ''">
                            <div class="content">
                                <div class="columns" formGroupName="alumnos_inicializacion">
                                    <div class="column is-4">
                                        <div class="b-checkbox is-info">
                                            <input id="inicializado" class="styled" [disabled]="ctrl.dato.controls.alumnos_inicializacion.get('inicializado').value == '1' ? true : false" [checked]="ctrl.dato.controls.alumnos_inicializacion.get('inicializado').value == '1' ? true : false" (change)="ctrl.dato.controls.alumnos_inicializacion.get('inicializado').patchValue(ctrl.dato.controls.alumnos_inicializacion.get('inicializado').value == '1' ? '0' : '1')"
                                                type="checkbox">
                                            <label for="inicializado">
                                                Finalizar incorpóración académica y financiera
                                            </label>
                                        </div>
                                    </div>
                                    <div class="column is-8">
                                        <label class="label">Si marca esta casilla y guarda los datos, ya "NO" será
                                            posible modificar
                                            nuevamente los datos:
                                            "Última colegiatura
                                            pagada". El sistema utilizará estos datos como referencia para el proceso de
                                            cobranza de
                                            colegiaturas </label>
                                    </div>
                                </div>
                                <div class="columns" formGroupName="alumnos_inicializacion">
                                    <div class="column is-4">
                                        <label class="label">Última colegiatura abonada</label>
                                        <div class="control has-icons-left has-icons-right">
                                            <div class="select">
                                                <select class="select" name="mes" [ngClass]="{'is-danger': ctrl.dato.controls.alumnos_inicializacion.get('mes').hasError('required') }" formControlName="mes">
                                                    <option value="0">Seleccione</option>
                                                    <option value="1">1a</option>
                                                    <option value="2">2a</option>
                                                    <option value="3">3a</option>
                                                    <option value="4">4a</option>
                                                    <option value="5">5a</option>
                                                    <option value="6">6a</option>
                                                </select>
                                            </div>
                                        </div>
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.alumnos_inicializacion.get('mes').hasError('required')">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.alumnos_inicializacion.get('mes').hasError('required')">Este
                                            campo es requerido.</span>
                                    </div>
                                    <div class="column is-4">
                                        <label class="label">Última colegiatura abonada incompleta?</label>
                                        <div class="control has-icons-left has-icons-right">
                                            <div class="b-checkbox is-info">
                                                <input id="completado" class="styled" [checked]="ctrl.dato.controls.alumnos_inicializacion.get('completado').value == 1 ? true : false" (change)="ctrl.dato.controls.alumnos_inicializacion.get('completado').patchValue(ctrl.dato.controls.alumnos_inicializacion.get('completado').value == 1 ? 0 : 1)"
                                                    type="checkbox">
                                                <label for="completado">
                                                    Si esta incompleta
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column is-4">
                                        <div class="field" *ngIf="ctrl.dato.controls.alumnos_inicializacion.get('completado').value == 1">
                                            <label class="label">Cantidad Abonada:</label>
                                            <p class="control has-icons-left has-icons-right">
                                                <input class="input" type="number" placeholder="Cantidad abonada" formControlName="ultimo_abono">

                                                <!-- <span class="help is-danger" *ngIf="!ctrl.dato.controls.alumnos_inicializacion.get('ultimo_abono').hasError('required')">Este campo es requerido.</span> -->
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--  Rfc   -->
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                <i class="fa fa-vcard is-size-4 has-text-grey-light"> </i> &nbsp; Datos para facturación
                            </p>
                            <a href="javascript:void()" class="card-header-icon" aria-label="more options" (click)="acordeon[9] = !acordeon[9]">
                                <span class="icon">
                                    <i class="fa " [ngClass]="acordeon[9] ? 'fa-angle-down' : 'fa-angle-up'"
                                        aria-hidden="true"></i>
                                </span>
                            </a>
                        </header>
                        <div class="card-content" [ngClass]="acordeon[9] ? 'is-hidden' : ''">
                            <div class="content">
                                <div class="columns" formArrayName="personas_rfcs" *ngIf="ctrl.dato.get('personas_rfcs').length > 0">
                                    <div class="column is-12">
                                        <div class="card" *ngFor="let medio of ctrl.dato.controls.personas_rfcs.controls; let i=index" [formGroupName]="i">
                                            <header class="card-header">
                                                <p class="card-header-title has-text-link" style="font-size: 1.25rem; margin: 0px">
                                                    <i class="fa fa-vcard is-size-4 has-text-grey-light"> </i> &nbsp; RFC # {{ i + 1 }}
                                                </p>
                                                <a href="javascript:void()" class="card-header-icon" aria-label="more options" (click)="ctrl.quitar_form_array(ctrl.dato.controls.personas_rfcs, i)">
                                                    <span class="icon has-text-danger">
                                                        <i class="icon-trash"></i>
                                                    </span>
                                                </a>
                                            </header>
                                            <div class="card-content">
                                                <div class="content">
                                                    <div class="columns">
                                                        <div class="column is-6">
                                                            <div class="field">
                                                                <label class="label">Razón Social:</label>
                                                                <p class="control has-icons-left has-icons-right">
                                                                    <input class="input" type="text" placeholder="Razón Social" formControlName="razon_social">

                                                                    <span class="help is-danger" *ngIf="!ctrl.dato.controls.personas_rfcs.controls[i].controls.razon_social.valid">Este
                                                                        campo es requerido.</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div class="column is-6">
                                                            <div class="field">
                                                                <label class="label">Rfc:</label>
                                                                <p class="control has-icons-left has-icons-right">
                                                                    <input class="input" type="text" placeholder="Rfc" formControlName="rfc">

                                                                    <span class="help is-danger" *ngIf="!ctrl.dato.controls.personas_rfcs.controls[i].controls.rfc.valid">Este
                                                                        campo es requerido.</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="columns">
                                                        <div class="column is-6">
                                                            <div class="field">
                                                                <div class="field">
                                                                    <label class="label">Correo eléctronico:</label>
                                                                    <p class="control has-icons-left has-icons-right">
                                                                        <input class="input" type="text" placeholder="Correo eléctronico" formControlName="email">

                                                                        <span class="help is-danger" *ngIf="!ctrl.dato.controls.personas_rfcs.controls[i].controls.email.valid">Este
                                                                            campo es requerido.</span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="column is-2">
                                                            <br>
                                                            <br>
                                                            <div class="field">
                                                                <div class="b-checkbox is-info is-circular">
                                                                    <input id="tipo_persona_f_{{i}}" name="tipo_persona" value="Fisica" class="styled" type="radio" formControlName="tipo_persona" (click)="ctrl.catalogoDependiente('tipo-regimen-fiscal', 'tipos_regimenes_fiscales', ctrl.dato.controls.personas_rfcs.controls[i].controls.tipo_persona.value, i);">
                                                                    <label for="tipo_persona_f_{{i}}">
                                                                        Fisica
                                                                    </label>

                                                                    <input id="tipo_persona_m_{{i}}" name="tipo_persona" value="Moral" class="styled" type="radio" formControlName="tipo_persona" (click)="ctrl.catalogoDependiente('tipo-regimen-fiscal', 'tipos_regimenes_fiscales', ctrl.dato.controls.personas_rfcs.controls[i].controls.tipo_persona.value, i);">
                                                                    <label for="tipo_persona_m_{{i}}">
                                                                        Moral
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="column is-4">
                                                            <label class="label">Tipos regimenes fiscales:</label>
                                                            <div class="select">
                                                                <select class="select" name="tipos_regimenes_fiscales_id" formControlName="tipos_regimenes_fiscales_id" >
                                                                    <option *ngFor="let item of ctrl.tipos_regimenes_fiscales[i] ; let i = index; " [value]="item.clave">({{item.clave}}) {{item.nombre}}</option>
                                                                </select>
                                                            </div>
                                
                                                        </div>
                                                    </div>
                                                    <div class="columns">

                                                        <div class="column is-4">
                                                            <label class="label">País:</label>
                                                            <div class="select">
                                                                <select class="select" name="pais" formControlName="paises_id" (change)="ctrl.catalogoDependiente('estados', 'estados',  medio.value.paises_id);">
                                                                    <option *ngFor="let item of ctrl.paises"
                                                                        value="{{item.id}}">{{item.nombre}}</option>
                                                                </select>
                                                            </div>

                                                        </div>

                                                        <div class="column is-4">
                                                            <label class="label">Estado:</label>
                                                            <div class="select">
                                                                <select class="select" name="estados" formControlName="estados_id" (change)="ctrl.catalogoDependiente('municipios', 'municipios',  medio.value.estados_id);">
                                                                    <option *ngFor="let item of ctrl.estados"
                                                                        value="{{item.id}}">{{item.nombre}}</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div class="column is-4">
                                                            <label class="label">Municipio:</label>
                                                            <div class="select">
                                                                <select class="select" name="municipios" formControlName="municipios_id">
                                                                    <option *ngFor="let item of ctrl.municipios"
                                                                        value="{{item.id}}">{{item.nombre}}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="columns">
                                                        <div class="column is-6">
                                                            <div class="field">
                                                                <label class="label">Direccion:</label>
                                                                <p class="control has-icons-left has-icons-right">
                                                                    <input class="input" type="text" placeholder="calle" formControlName="calle">
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div class="column is-3">
                                                            <div class="field">
                                                                <label class="label">Num. Exterior:</label>
                                                                <p class="control has-icons-left has-icons-right">
                                                                    <input class="input" type="text" placeholder="Num. Exterior" formControlName="numero_exterior">
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div class="column is-3">
                                                            <div class="field">
                                                                <label class="label">Num. Interior:</label>
                                                                <p class="control has-icons-left has-icons-right">
                                                                    <input class="input" type="text" placeholder="Num. Interior" formControlName="numero_interior">
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="columns">
                                                        <div class="column is-4">
                                                            <div class="field">
                                                                <label class="label">Localidad:</label>
                                                                <p class="control has-icons-left has-icons-right">
                                                                    <input class="input" type="text" placeholder="Localidad" formControlName="localidad">
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div class="column is-4">
                                                            <div class="field">
                                                                <label class="label">Col. / Fracc.:</label>
                                                                <p class="control has-icons-left has-icons-right">
                                                                    <input class="input" type="text" placeholder="Col. / Fracc." formControlName="colonia">
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div class="column is-4">
                                                            <div class="field">
                                                                <label class="label">Codigo Postal:</label>
                                                                <p class="control has-icons-left has-icons-right">
                                                                    <input class="input" type="text" placeholder="CP" formControlName="codigo_postal">
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="columns">
                                                        <div class="column is-12">
                                                            <div class="b-checkbox is-info is-circular text-success">
                                                                <input id="predeterminado_{{i}}" name="predeterminado" value="1" [checked]="medio.value.predeterminado == 1 ? true : false" (click)="predeterminado(medio.controls.predeterminado)" class="styled" type="radio" formControlName="predeterminado">
                                                                <label for="predeterminado_{{i}}">
                                                                    Al marcar la casilla, se emitirán las facturas con
                                                                    los datos de esta ficha
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="columns">
                                    <div class="column is-12">
                                        <div class="button is-primary is-outlined is-fullwidth" style="background: rgb(142, 204, 223); width:100%; ">
                                            <button type="button" class="button btn-lg is-success" (click)="ctrl.tipos_regimenes_fiscales[ctrl.dato.controls.personas_rfcs.controls.length] = []; ctrl.agregar_form_array(ctrl.dato.controls.personas_rfcs, form_personas_rfcs)">
                                                <i class="icon-add"></i> &nbsp; &nbsp; Agregar nuevo RFC
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!--  Validaciones -->
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                <i class="fa fa-asterisk is-size-4 has-text-grey-light"> </i> &nbsp; Validaciones
                            </p>
                            <a href="javascript:void()" class="card-header-icon" aria-label="more options" (click)="acordeon[10] = !acordeon[10]">
                                <span class="icon">
                                    <i class="fa " [ngClass]="acordeon[10] ? 'fa-angle-down' : 'fa-angle-up'"
                                        aria-hidden="true"></i>
                                </span>
                            </a>
                        </header>
                        <div class="card-content" [ngClass]="acordeon[10] ? 'is-hidden' : ''">
                            <div class="content">
                                <div class="columns">
                                    <div class="field">
                                        <div class="b-checkbox is-info">
                                            <input id="documentos_validados" class="styled" [checked]="ctrl.dato.controls.documentos_validados.value == 1 ? true : false" (change)="ctrl.dato.controls.documentos_validados.patchValue(ctrl.dato.controls.documentos_validados.value == 1 ? 0 : 1)" type="checkbox">
                                            <label for="documentos_validados">
                                                Marcar esta casilla si todos los documentos ya fueron validados
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--  Re-Validaciones -->
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                <i class="fa fa-check is-size-4 has-text-grey-light"> </i> &nbsp; Re-Validación de materias
                            </p>
                            <a href="javascript:void()" class="card-header-icon" aria-label="more options" (click)="acordeon[13] = !acordeon[13]">
                                <span class="icon">
                                    <i class="fa " [ngClass]="acordeon[13] ? 'fa-angle-down' : 'fa-angle-up'"
                                        aria-hidden="true"></i>
                                </span>
                            </a>
                        </header>
                        <div class="card-content" [ngClass]="acordeon[13] ? 'is-hidden' : ''">
                            <div class="content">
                                <div class="columns">
                                    <div class="field">
                                        <div class="b-checkbox is-info">
                                            <input id="proceso_revalidacion" class="styled" [checked]="ctrl.dato.controls.proceso_revalidacion.value == 1 ? true : false" (change)="ctrl.dato.controls.proceso_revalidacion.patchValue(ctrl.dato.controls.proceso_revalidacion.value == 1 ? 0 : 1)" [disabled]="ctrl.dato.controls.revalidaciones_id.value != null ? true : false"
                                                type="checkbox">
                                            <label for="proceso_revalidacion">
                                                Al marcar está casilla se indica que el alumno revalidará materias que
                                                cursó en otra institución educativa, el proceso siguiente es dirigirse
                                                al módulo de revalidación de materias, una vez validadas las materias
                                                debe realizar su pago.
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--  Datos de Pago -->
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                <i class="fa fa-info-circle is-size-4 has-text-grey-light"> </i> &nbsp; Datos obligatorios para pagos
                            </p>
                            <a href="javascript:void()" class="card-header-icon" aria-label="more options" (click)="acordeon[11] = !acordeon[11]">
                                <span class="icon">
                                    <i class="fa " [ngClass]="acordeon[11] ? 'fa-angle-down' : 'fa-angle-up'"
                                        aria-hidden="true"></i>
                                </span>
                            </a>
                        </header>
                        <div class="card-content" [ngClass]="acordeon[11] ? 'is-hidden' : ''">
                            <div class="content">
                                <div class="columns">
                                    <div class="column is-6">
                                        <label class="label">Generar "Referencia Bancaria" automáticamente</label>
                                        <div class="control has-icons-left has-icons-right">
                                            <div class="b-checkbox is-info">
                                                <input id="referencia_bancaria_automatica" class="styled" [checked]="ctrl.dato.controls.referencia_bancaria_automatica.value == 1 ? true : false" (change)="ctrl.dato.controls.referencia_bancaria_automatica.patchValue(ctrl.dato.controls.referencia_bancaria_automatica.value == 1 ? 0 : 1)"
                                                    type="checkbox">
                                                <label for="referencia_bancaria_automatica">
                                                    Sustituye la referencia anterior
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="column is-6">
                                        <label class="label">Referencia bancaria:</label>
                                        <p class="control has-icons-left has-icons-right">
                                            <input class="input" type="text" placeholder="Referencia bancaria" formControlName="referencia_bancaria">
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--  Matrícula -->
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                <i class="fa fa-info-circle is-size-4 has-text-grey-light"> </i> &nbsp; Matrícula
                            </p>
                            <a href="javascript:void()" class="card-header-icon" aria-label="more options" (click)="acordeon[12] = !acordeon[12]">
                                <span class="icon">
                                  <i class="fa " [ngClass]="acordeon[12] ? 'fa-angle-down' : 'fa-angle-up'" aria-hidden="true"></i>
                                </span>
                            </a>
                        </header>
                        <div class="card-content" [ngClass]="acordeon[12] ? 'is-hidden' : ''">
                            <div class="content">
                                <div class="columns">
                                    <div class="column is-6">
                                        <p> Realice cambios de matrícula de manera grupal en el módulo de Matriculación
                                        </p>
                                    </div>
                                    <div class="column is-6">
                                        <div class="field">
                                            <label class="label">Matrícula:</label>
                                            <div class="control is-expanded  has-icon has-icon-left">
                                                <input class="input" type="text" placeholder="Matrícula" formControlName="matricula">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </form>
        </div>
    </div>
</div>